import { Box, Flex } from '@chakra-ui/react';
import { Button, Modal, ModalProps, Text } from '@melio/penny';
import { useAnalytics } from '@melio/platform-analytics';
import { useMelioIntl } from '@melio/platform-i18n';
import { useEffect } from 'react';

type AmountsMismatchModalProps = Pick<ModalProps, 'isOpen'> & {
  onAdd: VoidFunction;
  onRemove: VoidFunction;
  mismatchedValue: string;
};

export const AmountsMismatchModal = ({ isOpen, onAdd, onRemove, mismatchedValue }: AmountsMismatchModalProps) => {
  const { formatMessage } = useMelioIntl();
  const { track } = useAnalytics();
  useEffect(() => {
    if (isOpen) {
      track('AmountMismatchModal', 'View');
    }
  }, [isOpen, track]);

  const handleAdd = () => {
    track('AmountMismatchModal', 'Click', {
      Cta: 'add',
    });
    onAdd();
  };
  const handleRemove = () => {
    track('AmountMismatchModal', 'Click', {
      Cta: 'remove',
    });
    onRemove();
  };
  return (
    <Modal isOpen={isOpen} onClose={onAdd} data-testid="amounts-mismatch-modal" shouldHideCloseButton>
      <Flex direction="column" alignSelf="flex-start" ml={5} mr={5} mb={5} mt={5}>
        <Box mb={5}>
          <Text textStyle="heading2Semi">
            {formatMessage('widgets.ReviewScannedInvoice.amountsMismatchModal.title')}
          </Text>
        </Box>
        <Text>
          {formatMessage('widgets.ReviewScannedInvoice.amountsMismatchModal.content', { diff: mismatchedValue })}
        </Text>
      </Flex>
      <Flex justifyContent="flex-end" gap={3}>
        <Button
          data-testid="amounts-mismatch-modal-remove-button"
          variant="secondary"
          onClick={handleRemove}
          label={formatMessage('widgets.ReviewScannedInvoice.amountsMismatchModal.removeButtonText')}
        />
        <Button
          data-testid="amounts-mismatch-modal-add-button"
          variant="primary"
          onClick={handleAdd}
          label={formatMessage('widgets.ReviewScannedInvoice.amountsMismatchModal.addButtonText')}
        />
      </Flex>
    </Modal>
  );
};
